import React, { useEffect, useState } from 'react'
import { NotificationServices } from '../NotificationServices';
import { set } from 'zod';
import { DataGrid } from '@mui/x-data-grid';
import Loading from '../../../../components/Loader/Loading';
import { Box, Button, Card, Typography, useMediaQuery, useTheme } from '@mui/material';
import useResponsive from '../../../../hooks/useResponsive';
import NoRowsLayout from '../../../../components/Layout/NoRowsLayout';
import { PermissionGuard } from '../../../../components/PermissionGuard';

const WhatsappMessageList = (props) => {
  const {id} = props;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const {isSm} = useResponsive();
  const [messageList,setMessageList] = useState([]);
  const [isLoading,setIsLoading] = useState(false);
  const columns = [
    {
      field:'receiverUserId',
      headerName:"Receiver",
      flex:.5,
      sortable:false,
      headerAlign:'center',
      // minWidth:100,
      renderCell: (params) => {
        return (
          <Box sx={{ p: 1, display: 'flex',flexDirection:'column',gap:1 ,justifyContent: 'center',alignItems:'center',width:'100%' }}>          
            <Typography sx={{fontSize:'0.75rem'}}>{params.row?.to}</Typography>
          </Box>
        )
      }
    },
    {
      field:'status',
      headerName:"Status",
      flex:.5,
      sortable:false,
      headerAlign:'center',
      // minWidth:100,
      renderCell: (params) => {
        return (
          <Box sx={{ p: 1, display: 'flex',flexDirection:'column',gap:1 ,justifyContent: 'center',alignItems:'center',width:'100%' }}>          
            <Typography sx={{fontSize:'0.75rem'}}>{params.value}</Typography>
          </Box>
        )
      }
    },
    {
      field:'firebaseResponse',
      headerName:"Error Message",
      flex:1,
      sortable:false,
      headerAlign:'center',
      // minWidth:100,
      renderCell: (params) => {
        let message = params.row.error?.message || '';

        
        return (
          <Box sx={{ p: 1, display: 'flex',flexDirection:'column',gap:1 ,justifyContent: 'center',alignItems:'center',width:'100%' }}>          
            <Typography sx={{fontSize:'0.75rem'}}>{message}</Typography>
          </Box>
        )
      }
    },
    // {
    //   field:'deviceId',
    //   headerName:"Device",
    //   flex:1,
    //   sortable:false,
    //   headerAlign:'center',
    //   // minWidth:100,
    //   renderCell: (params) => {
    //     return (
    //       <Box sx={{ p: 1, display: 'flex',flexDirection:'column',gap:1 ,justifyContent: 'center',alignItems:'center',width:'100%' }}>          
    //         <Typography sx={{fontSize:'0.75rem'}}>{params.value}</Typography>
    //       </Box>
    //     )
    //   }
    // },
    // {
    //   field:'readStatus',
    //   headerName:"Read Status",
    //   flex:.5,
    //   sortable:false,
    //   headerAlign:'center',
    //   // minWidth:100,
    //   renderCell: (params) => {
    //     return (
    //       <Box sx={{ p: 1, display: 'flex',flexDirection:'column',gap:1 ,justifyContent: 'center',alignItems:'center',width:'100%' }}>          
    //         <Typography sx={{fontSize:'0.75rem'}}>{params.value}</Typography>
    //       </Box>
    //     )
    //   }
    // },
    
    // {
    //   field:'action',
    //   headerName:"Action",
    //   headerAlign:'center',
    //   flex:.5,
    //   sortable:false,
    //   // minWidth:100,
    //   renderCell: (params) => {
    //     return (
    //       <Box sx={{ p: 1, display: 'flex',flexDirection:'column',gap:1 ,justifyContent: 'center',alignItems:'center',width:'100%' }}>          
    //         <PermissionGuard feature='notification' permission='canView'>
    //           <Button size='small' color='primary' variant='outlined' sx={{textTransform:"capitalize",fontSize:'.6rem',p:.25}} 
    //             // onClick={()=>window.open(`/notification/${params.row.notificationId}`,'_blank')}
    //           >
    //             View
    //           </Button>
    //         </PermissionGuard>
    //       </Box>
    //     )
    //   }
    // },
  ]
  const fetchMessages = async() => {
    setIsLoading(true);
    console.log("fetch messages of campaign id",id);
    const messages = await NotificationServices.fetchCampaignMessages({
      notificationId:id
    });
    console.log("messages",messages);
    if(messages.success == '1'){
      setMessageList(messages.data);
    }else if(messages.success == '0'){
      setMessageList([]);
      console.log("Error in fetching messages:",messages.message);
    }
    setIsLoading(false);

  }
  useEffect(()=>{
    if(id){
      fetchMessages();
    }
  },[id])
  return (
    <>
      <Card sx={{ minWidth: "100%", marginBottom: ".5%"}}>
          <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
            <Typography sx={{fontWeight:600,fontSize:'0.85rem'}} >Message List</Typography>
          </Box>
          <Box sx={{ overflow: "auto" }}>
              {isLoading && <Loading />}
              <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff", borderRadius: '.5rem' }}>
                <DataGrid
                    rows={messageList}
                    columns={columns.map((col) => ({
                    ...col,
                    // flex: col.flex || 1, // Ensure columns resize dynamically
                    minWidth: isSmallScreen && (col.minWidth || 150), // Set a minimum width to avoid overlap
                    }))}
                    getRowId={(row) => row._id}
                    //checkboxSelection={true}
                    rowCount={messageList.length}  // Use the length of the filtered list
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    initialState={{
                      pagination: { paginationModel: { pageSize: 10, page: 0 } }, // <-- Set default pageSize to 15
                    }}
                    // paginationModel={paginationModel}
                    // paginationMode="server"
                    // onPaginationModelChange={handlePaginationChange}

                    // filterModel={filterModel}

                    // sortingMode="server"
                    // sortModel={sortModel}
                    // onSortModelChange={handleSortingChange}

                    loading={isLoading}

                    disableColumnMenu
                    disableRowSelectionOnClick
                    slots={{
                    // toolbar: GridToolbar,                        
                    loadingOverlay: Loading,
                    noRowsOverlay: () => <NoRowsLayout message="No Messages Found" />,
                    }}
                    autoHeight
                    getRowHeight={() => 'auto'}
                    sx={{
                    '& .MuiDataGrid-cell': {
                        border: 1,
                        borderRight: 0,
                        borderTop: 0,
                        borderColor: 'lightgrey',
                        display: 'flex',
                        alignItems: 'center',
                        // justifyContent: 'center',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '2px solid rgba(224, 224, 224, 1)',
                        borderTop: '2px solid rgba(224, 224, 224, 1)',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        p: 0,
                        height: 'fit-content',
                        minHeight: '0 !important',
                        height: '2rem'
                    },
                    '& .MuiDataGrid-columnHeader': {
                        borderLeft: '1px solid rgba(224, 224, 224, 1)',
                        '&:last-child': {
                        borderRight: 'none',
                        },
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: 600,
                        color: '#3e3e3e'
                    },
                    '& .MuiDataGrid-row': {
                        '&:last-child .MuiDataGrid-cell': {
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        },
                        '& .MuiDataGrid-cell:last-child': {
                        borderRight: 'none',
                        },
                    },
                    '& .MuiDataGrid-columnSeparator': {
                        display: 'none',
                    },
                    }}
                />
              </Box>
          </Box>
        </Card>
    </>
  )
}

export default WhatsappMessageList
